<template>
  <div>
      总公司角色管理
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>